import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import Offers from './offers';
import { getOffers, isLoaded } from '../redux/modules/tv';
import * as date from '../utils/date-fns';
import DetailTextSection from '../DetailTextSection';
import { getDetailText } from '../redux/modules/detailText';

const Bundle = __CLIENT__ ? require('../common/bundle').default : null;
const Article = __CLIENT__
  ? require('bundle-loader?lazy!./article.js')
  : require('./article.js').default;

const OFFER_TYPE = 'tv';

/** Read and decode ':filter' from router props */
function getFilterFromProps(props) {
  const m = props && props.match;
  return decodeURIComponent((m && m.params && m.params.filter) || '');
}

export default class Tv extends Component {
  static async fetchData({ getState, dispatch, params, match }) {
    if (!isLoaded({ getState })) {
      await dispatch(getOffers());
    }
    const filter =
      (params && params.filter) ||
      (match && match.params && match.params.filter) ||
      '';
    if (filter) {
      await dispatch(getDetailText(OFFER_TYPE, filter));
    }
  }

  render() {
    const { match, location, feed } = this.props;
    const filter = getFilterFromProps(this.props);

    return (
      <DocumentMeta
        title={`${
          match.params && match.params.filter ? match.params.filter + ' ' : ''
        }TV udbydere, spar penge med en billig TV pakke (${date.format(
          new Date(),
          'MMMM \'YY'
        )})`}
        canonical="/tv-udbydere"
        extend
      >
        <Offers {...this.props} />

        <hr />

        <DetailTextSection
          offerType={OFFER_TYPE}
          filter={filter}
          location={location}
          feed={feed}
          fallback={
            __CLIENT__ ? (
              <Bundle load={Article}>{Comp => (Comp ? <Comp /> : null)}</Bundle>
            ) : (
              <Article />
            )
          }
        />
      </DocumentMeta>
    );
  }
}
